exports = module.exports = require("./../node_modules/.npminstall/css-loader/0.21.0/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".carousel-control[_v-1c253780] {\n  cursor: pointer;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/.npminstall/css-loader/0.21.0/css-loader!./~/.npminstall/vue-loader/7.1.7/vue-loader/lib/style-rewriter.js?id=_v-1c253780&file=Carousel.vue&scoped=true!./~/.npminstall/vue-loader/7.1.7/vue-loader/lib/selector.js?type=style&index=0!./src/Carousel.vue
// module id = 221
// module chunks = 0